import { useEffect, useState } from 'react';

import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import useMediaQuery from '@skyscanner-internal/backpack-web/bpk-component-breakpoint/src/useMediaQuery';
import { isLoggedIn } from 'saddlebag-user-management';

import { isBrowser } from '../../../utils/isEnv';

import { useCookieBannerDismissed } from './useCookieBannerDismissed';

type UseAutoPromptGateOptions = {
  market: string | undefined;
};

export const useAutoPromptGate = ({
  market,
}: UseAutoPromptGateOptions): boolean => {
  const isTabletOrSmaller = useMediaQuery(BREAKPOINTS.TABLET);
  const cookieBannerDismissed = useCookieBannerDismissed(market);
  const [loggedIn, setLoggedIn] = useState<boolean | null>(null);

  useEffect(() => {
    if (!isBrowser()) return undefined;
    let cancelled = false;
    isLoggedIn().then((result: boolean) => {
      if (!cancelled) setLoggedIn(result);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isBrowser()) return false;

  return (
    loggedIn === false && !isTabletOrSmaller && cookieBannerDismissed === true
  );
};
